requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!window.LookbookSection) {
      class LookbookSection extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.items = this.querySelectorAll('.lookbook__item');
          this.columns = this.querySelectorAll('.lookbook__column');

          this.items.forEach((element, index) => {
            element.addEventListener('mouseenter', () => {
              this.columns[index].classList.add('active');
              this.columns.forEach(el => el.classList.remove('selected'));
            });
            element.addEventListener('mouseleave', () => {
              this.columns[index].classList.remove('active');
            });
            element.addEventListener('click', () => {
              if (this.isMobileVersion && themeBase.isDesktop) {
                return;
              }

              this.columns[index].classList.add('selected');
              window.scrollTo({
                top: this.columns[index].offsetTop + this.columns[index].offsetHeight,
                behavior: 'smooth'
              });
            });
          });

          this.columns.forEach((element, index) => {
            element.addEventListener('mouseenter', () => {
              this.items[index].classList.add('active');
              this.columns.forEach(el => el.classList.remove('selected'));
            });
            element.addEventListener('mouseleave', () => {
              this.items[index].classList.remove('active');
            });
          });
        }

        disconnectedCallback() {

        }
      }

      window.LookbookSection = LookbookSection;
    }

    if (!customElements.get('lookbook-section')) {
      customElements.define('lookbook-section', LookbookSection);
    }

    if (!customElements.get('lookbook-section-mobile')) {
      class LookbookSectionMobile extends LookbookSection {
        constructor() {
          super();
          this.isMobileVersion = true;
        }
      }

      themeBase.viewportFunction(false, () => customElements.define('lookbook-section-mobile', LookbookSectionMobile));
    }
  });
});